import { render, staticRenderFns } from "./nearme.vue?vue&type=template&id=4522f65c&scoped=true"
import script from "./nearme.vue?vue&type=script&lang=js"
export * from "./nearme.vue?vue&type=script&lang=js"
import style0 from "./nearme.vue?vue&type=style&index=0&id=4522f65c&prod&lang=scss&scoped=true"
import style1 from "./nearme.vue?vue&type=style&index=1&id=4522f65c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4522f65c",
  null
  
)

export default component.exports